"use client"

import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogTitle, DialogTrigger } from "./ui/dialog";
import CompanyForm from "./CompanyForm";
import { useState } from "react";
import { CompanyFormSchema } from "@/schemas/company-form.schema";
import { z } from "zod";
import { addCompany } from "@/services/companies.service";
import { CompanySchema } from "@/schemas/company.schema";

interface Props {
    onAddSuccess?: (company: z.infer<typeof CompanySchema>) => void
}

export default function AddCompanyModal(props: Props) {
    const [open, setOpen] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const handleOnSubmit = async (data: z.infer<typeof CompanyFormSchema>) => {
        try {
            setIsLoading(true);
            const company = await addCompany(data);
            handleSuccess(company);
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    }

    const handleSuccess = (company: z.infer<typeof CompanySchema>) => {
        setIsLoading(false);
        setOpen(false);
        props.onAddSuccess?.(company);
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button className="cursor-pointer">Add company</Button>
            </DialogTrigger>
            <DialogContent className="max-w-sm">
                <DialogTitle>Add company</DialogTitle>
                <CompanyForm onSubmit={handleOnSubmit} isLoading={isLoading} />
            </DialogContent>
        </Dialog>
    )
}